import { Router, RouteConfig } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { Account, Customer } from '../../models/customer';
import { State } from '../../services/global-state';
import { Business } from '../../models/business';
import { EventAggregator } from 'aurelia-event-aggregator';
import { mock, instance, when, verify, resetCalls, anything } from 'ts-mockito';
import { SetupRecurring } from './setup-recurring';
import { PayrazrService } from '../../services/payrazr';
import { ApplePaySettings, ApplePayUtil, DigitalWalletSettings, DigitalWalletType } from '../../models/digital-wallet';
import * as moment from 'moment';
import { PortalTemplateTypes } from '../../services/template-service';

describe('NewPortalWeb', () => {
	describe('pages', () => {
		describe('recurring', () => {
			describe('setup-recurring', () => {
				let component: SetupRecurring;
				const mockRouter: Router = mock(Router);
				let stubState: State;
				const mockI18N: I18N = mock(I18N);
				const mockEventAggregator: EventAggregator = mock(EventAggregator);
				const mockBusiness: Business = mock(Business);
				const mockPayrazrService: PayrazrService = mock(PayrazrService);
				const mockAccount: Account = mock(Account);
				const mockApplePaySettings: ApplePaySettings = mock(ApplePaySettings);
				let stubMockEvent: CustomEvent;

				let portalSettings = {
					portfolioKey: 7845,
					name: 'Z2305422 Default Portfolio',
					settings: {
						paymentTypes: {
							rehab: {
								email: null,
								phone: null,
								address1: null,
								address2: null,
								address3: null,
								taxTransactionType: null,
								taxTranscriptType: '1040-C',
								payInFull: null,
								settleNow: null,
								firstPaymentLimit: null
							},
							maxFutureDays: 1,
							allowSingle: true,
							allowFuture: true,
							allowRehab: false,
							allowInstallments: false,
							installments: {
								maxFirstInstallmentFutureDays: 10,
								numberOfRetriesForCardDeclines: 0,
								balanceRanges: [
									{
										min: 1,
										max: 9999999,
										payInFull: true,
										payInFullDiscountPercent: 0,
										enableInstallments: true,
										enableNegotiator: true,
										installments: [
											{
												number: 2,
												discountPercent: 0
											},
											{
												number: 4,
												discountPercent: 2
											},
											{
												number: 8,
												discountPercent: 4
											}
										],
										recurringPaymentsFrequencies: [
											{
												id: 1,
												name: 'Weekly'
											},
											{
												id: 3,
												name: 'Every 28 Days'
											},
											{
												id: 5,
												name: '15th of each month'
											},
											{
												id: 7,
												name: 'Every 2 months'
											},
											{
												id: 6,
												name: 'End of month'
											},
											{
												id: 4,
												name: 'Monthly'
											},
											{
												id: 2,
												name: 'Every 2 weeks'
											}
										]
									}
								],
								recurringPaymentsFrequencies: []
							},
							allowRecurring: true,
							recurring: {
								maxFirstRecurringPaymentFutureDays: 30,
								maxLastRecurringPaymentFutureDays: null,
								hideTheIndefiniteIndicator: false,
								numberOfRetriesForCardDeclines: 0,
								paymentFrequencies: [
									{
										id: 4,
										name: 'Monthly'
									},
									{
										id: 1,
										name: 'Weekly'
									},
									{
										id: 3,
										name: 'Every 28 Days'
									},
									{
										id: 5,
										name: '15th of each month'
									},
									{
										id: 7,
										name: 'Every 2 months'
									},
									{
										id: 6,
										name: 'End of month'
									},
									{
										id: 2,
										name: 'Every 2 weeks'
									}
								]
							},
							enableMinimumPaymentDueOnAccount: false,
							allowConsumersToCancelSingleFutureOnPortal: true,
							allowConsumerToCancelPaymentPlan: true,
							allowConsumersToSkipAPayment: true,
							maximumNumberOfPaymentsAConsumerCanSkip: 2
						},
						paymentMethods: {
							allowCreditCard: true,
							allowAch: true
						},
						minimumPaymentAmount: 1,
						maximumPaymentAmount: 9999999,
						enablePayByText: false,
						maxFutureDays: 0,
						multiplePaymentLimit: {
							enabled: true,
							limit: 2
						},
						rehabPlanOptions: [
							{
								id: 1,
								name: 'Monthly'
							}
						]
					},
					merchantSettings: {
						merchantKey: 7796,
						zid: 'Z2305422',
						maxFutureDays: 45,
						canProcessAch: true,
						canProcessCreditCard: true,
						acceptsDebit: true,
						acceptsCredit: true,
						thirdPartyIntegrationSettings: {
							platform: 0,
							attributes: {}
						},
						accountNumberFormat: null,
						hasAccountTypeFor3rdParty: false,
						isAccountTypeVisible: false,
						isAccountTypeRequired: false,
						portalRegistrationWithoutZipCode: false,
						requireMinPayment: false,
						maximumPayment: 0,
						feeSettings: {
							serviceFeeAmount: 0,
							allowServiceFeesOnEveryTransaction: false,
							serviceFeeEnabled: false,
							allowFeesOnAutopays: false,
							allowServiceFeesOnEveryAutopayTransaction: true
						},
						sendPlanReceiptToMerchant: false,
						merchantConfiguredReceiptEmails: '',
						cardsAccepted: {
							amex: true,
							cartblanch: true,
							diners: true,
							discover: true,
							jal: true,
							jcb: true,
							mastercard: true,
							visa: true
						},
						defaultFeeDisclosure: null
					},
					paymentTypes: {},
					paymentMethods: {
						allowAch: true,
						allowCreditCard: true,
						acceptsDebit: true,
						acceptsCredit: true
					},
					autopaySettings: {
						portfolioKey: 7845,
						enableAutopay: true,
						payInFullOnly: false,
						numberofRetriesForCardDeclines: 0,
						maxFutureStartDateInDays: 30,
						autopayPaymentOptions: [
							{
								portfolioKey: 7845,
								autopayRuleType: 1,
								autopayRuleValue: 0
							}
						],
						selectableDaysOfMonth: null
					}
				};

				let currentCustomer: Customer;

				const i18next = {
					t: (a, b) => a
				};

				let applePaySettings: ApplePaySettings = new ApplePaySettings(mockI18N, stubState);
				applePaySettings.isApplePay = () => true;

				beforeEach(() => {
					stubState = new State(
						instance(mockI18N),
						instance(mockEventAggregator)
					);

					stubState.business = instance(mockBusiness);
					stubState.business.fetchPortfolioSettings = () => portalSettings;

					currentCustomer = new Customer(stubState.business);

					stubState.customer = currentCustomer;

					spyOn(stubState.business, 'fetchPortfolioSettings').and.callFake(() => portalSettings);

					when(mockI18N.i18next).thenReturn(i18next);

					component = new SetupRecurring(
						instance(mockRouter),
						stubState,
						instance(mockPayrazrService),
						instance(mockI18N)
					);

					resetCalls(mockRouter);
				});

				afterEach(() => {
					component.account = null;
				});

				it('should initialize SetupRecurring component', () => {
					expect(component).toBeTruthy();
				});

				describe('goBack()', () => {

					it('should redirect to secure', () => {

						when(mockRouter.navigateToRoute('secure')).thenReturn();
						component.goBack();

						verify(mockRouter.navigateToRoute('secure')).called();

					});
				});

				describe('activate()', () => {

					let account = instance(mockAccount);
					const model = { id: '123' };

					beforeEach(() => {
						stubState.customer = currentCustomer;
						stubState.customer.accounts = Array<Account>();
						account.id = '123';
						account.portfolioName = 'portfolioName';
						stubState.customer.accounts.push(account);
						stubState.customer.portfolios = [{
							portfolioName: 'portfolioName'
						}];

					});

					it('should last payment date option radio button selected by default', () => {

						component.activate(model);

						expect(stubState.business.fetchPortfolioSettings).toHaveBeenCalled();
						expect(component.lastPaymentDateOptionSelected).toBe(component.lastPaymentDateRadioByDate.id);

					});
				});

				describe('next()', () => {
					beforeEach(() => {
						spyOn(component, 'validate');
						spyOn(component, 'paymentInformationFromForm');
						spyOn(component, 'getConfirmationTemplateData');
						spyOn(component, 'showConfirmation');
					});

					describe('Apple Pay', () => {
						beforeEach(() => {
							component.isDigitalWallet = true;
							spyOn(component, 'setApplePaySettingsRecurringFields');
						});

						it(('should set Apple recurring fields and show confirmation when Apple Pay'), () => {
							// Arrange
							mockApplePaySettings.isApplePay = () => true;
							stubMockEvent = new CustomEvent('mockNextEvent', {
								detail: {
									errors: [],
									digitalWalletSettings: mockApplePaySettings
								}
							});

							// Act
							component.next(stubMockEvent);

							// Assert
							expect(component.setApplePaySettingsRecurringFields).toHaveBeenCalledTimes(1);
							expect(component.getConfirmationTemplateData).toHaveBeenCalledTimes(1);
							expect(component.showConfirmation).toHaveBeenCalledTimes(1);
						});
					});
				});

				describe('submit()', () => {
					beforeEach(() => {
						component.paymentInformation = {};
						spyOn(component, 'navigateToReceipt');
					});

					describe('Apple Pay', () => {
						beforeEach(() => {
							component.isDigitalWallet = true;
							spyOn(ApplePayUtil, 'completeSession');
						});

						it(('should set submit recurring plan when Apple Pay'), async () => {
							// Arrange
							const expectedMerchantKey = Math.floor(Math.random() * 10);
							const expectedPlanId = Math.floor(Math.random() * 10);
							const expectedPaymentDate = moment(moment.tz(stubState.business.businessTimezone).format('MM/DD/YYYY'));

							mockApplePaySettings.isApplePay = () => true;
							stubMockEvent = new CustomEvent('mockNextEvent', {
								detail: {
									errors: [],
									digitalWalletSettings: mockApplePaySettings,
									calculatedServiceFee: Math.floor(Math.random() * 10)
								}
							});

							component.paymentInformation = {
								digitalWalletSettings: stubMockEvent.detail.digitalWalletSettings
							};

							await spyOn(component, 'handleSaveToWallet').and.returnValue(Promise.resolve({ isSuccessful: true }));
							await spyOn(component, 'callApiBasedOnPaymentMechanism')
								.and.returnValue(Promise.resolve(
									{
										response:
										{
											isSuccessful: true,
											merchantKey: expectedMerchantKey,
											planId: expectedPlanId
										}
									}));

							// Act
							await component.submit(stubMockEvent);

							// Assert
							expect(component.paymentDate)
								.toEqual(expectedPaymentDate);
							expect(component.paymentInformation.savedPaymentMethodToWallet)
								.toEqual(undefined);
							expect(component.paymentInformation.merchantKey)
								.toEqual(expectedMerchantKey);
							expect(component.paymentInformation.planId)
								.toEqual(expectedPlanId);
							expect(component.paymentInformation.portalTemplateType)
								.toEqual(PortalTemplateTypes.CreditCardRecurringPaymentPlanReceipt);
							expect(ApplePayUtil.completeSession)
								.toHaveBeenCalledTimes(1);
						});

						it(('should complete Apple Pay session when callApiBasedOnPaymentMechanism() fails'), async () => {
							// Arrange
							stubMockEvent = new CustomEvent('mockNextEvent', {
								detail: anything()
							});

							component.paymentInformation = {
								digitalWalletSettings: stubMockEvent.detail.digitalWalletSettings
							};

							await spyOn(component, 'handleSaveToWallet')
								.and
								.returnValue(Promise.resolve({ isSuccessful: true }));

							await spyOn(component, 'callApiBasedOnPaymentMechanism')
								.and
								.returnValue(Promise.reject());

							// Act
							await component.submit(anything());

							// Assert
							expect(component.isSubmitting)
								.toBeFalse();
							expect(ApplePayUtil.completeSession)
								.toHaveBeenCalledTimes(1);
						});
					});
				});
			});
		});
	});
});
